<template>
  <el-input
    :placeholder="placeholder"
    v-model="inputVal"
    :maxlength="maxlength"
    :disabled="disabled"
    :clearable="clearable"
    :plain="plain"
    :min="min"
    :class="className"
    :style="styles"
    :size="size"
    @input="handleInput($event)"
    @change="change"
    @blur="blur"
  >
    <template slot="append" v-if="hasAppend">{{ appendContent }}</template>
  </el-input>
</template>

<script>
export default {
  props: {
    placeholder: {
      type: [String, Number],
      default: "",
    },
    value: {
      type: [String, Number],
      default: "",
    },
    plain: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: "",
    },
    min: {
      type: [String, Number],
      default: "",
    },
    className: {
      type: String,
      default: "",
    },
    styles: {
      type: [String, Object],
      default: "",
    },
    maxlength: {
      type: [String, Number],
      default: -1,
    },
    hasAppend: {
      // 是否有append 插槽
      type: Boolean,
      default: false,
    },
    appendContent: {
      type: String,
      default: "",
    },
    /**
     * @param  type
     * number：数字输入框，只允许输入数字
     * price: 金额输入框，保留两位小数
     */
    type: {
      type: String,
      default: "productCode",
    },
  },
  data() {
    return {
      inputVal: "",
      number: /\D/g,
      // 此处可以添加任意key，值为对应正则表达式，如添加下面正则，在外面使用时，就可以直接type="minNumber"限制输入框不能输入小于1的数字
      minNumber: /^(0+)|\D/g, // 不能输入小于1的数字
    };
  },
  watch: {
    value: {
      handler(val) {
        this.inputVal = val;
      },
      deep: true,
      immediate: true, // 回显值使用
    },
  },
  methods: {
    handleInput(v) {
      let formatValue;
      if (this.type === "price") {
        // 金额输入框处理（比较复杂的输入框限制逻辑，单独限制）
        formatValue = ("" + v) // 第一步：转成字符串
          .replace(/[^\d.]/g, "") // 清除"数字"和"."以外的字符
          .replace(/^\./g, "") // 验证第一个字符是数字
          .replace(/^0{2,}/g, "0") //若0开头，只保留一个0
          .replace(/^0\d*/g, "0") //若0开头，0后只能是 "."
          .replace(/\.{2,}/g, ".") // 只保留第一个, 清除多余的
          .replace(".", "$#$")
          .replace(/\./g, "")
          .replace("$#$", ".")
          .replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3"); // 只能输入2个小数
      } else if (this.type === "positiveInteger") {
        //正整数
        formatValue = ("" + v) // 第一步：转成字符串
          .replace(/[^\d]/g, "") // 清除"数字"以外的字符
          .replace(/^0\d*/g, '')
      } else {
        // 其他输入框处理
        formatValue = v.replace(this[this.type], "");
      }
      this.inputVal = formatValue;
      this.$emit("update:value", formatValue);
      this.$emit("input", formatValue);
    },
    change(v) {
      this.$emit("change", v);
    },
    blur(e) {
      this.$emit("blur", e);
    },
  },
  mounted() {},
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/MyInput/index.vue